import React, { useState } from "react";
import { subscribeNewsletter } from "../api/subscribeApi";

const NewsletterSubscribe = ({ className, buttonText = "Subscribe", darkMode = false }) => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState({ type: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setFormStatus({
        type: "error",
        message: "Please enter your email address",
      });
      return;
    }

    // Reset form status
    setFormStatus({ type: "", message: "" });
    setIsSubmitting(true);

    try {
      const response = await subscribeNewsletter(email);
      console.log("[NewsletterSubscribe] Subscription successful:", response);

      setFormStatus({
        type: "success",
        message: response.already_subscribed ? "You are already subscribed to our newsletter!" : "Thank you for subscribing to our newsletter!",
      });

      setEmail("");
    } catch (error) {
      console.error("[NewsletterSubscribe] Subscription error:", error);
      setFormStatus({
        type: "error",
        message: error.message || "Failed to subscribe. Please try again later.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const bgColor = darkMode ? "bg-gray-900" : "bg-gray-50";
  const borderColor = darkMode ? "border-gray-700" : "border-gray-300";
  const textColor = darkMode ? "text-white" : "text-black";
  const placeholderColor = darkMode ? "placeholder-gray-500" : "placeholder-gray-400";
  const successBgColor = darkMode ? "bg-green-900" : "bg-green-100";
  const successTextColor = darkMode ? "text-green-300" : "text-green-800";
  const errorBgColor = darkMode ? "bg-red-900" : "bg-red-100";
  const errorTextColor = darkMode ? "text-red-300" : "text-red-800";

  return (
    <div className={`${className}`}>
      <h3 className={`text-xl font-semibold mb-3 ${textColor}`}>Stay Updated</h3>
      <p className={`mb-4 ${darkMode ? "text-gray-400" : "text-gray-600"}`}>Subscribe to our newsletter for the latest updates and news.</p>

      {formStatus.message && (
        <div
          className={`mb-4 p-3 rounded-lg ${
            formStatus.type === "success" ? `${successBgColor} ${successTextColor}` : `${errorBgColor} ${errorTextColor}`
          }`}
        >
          {formStatus.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          name="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
          className={`flex-grow ${bgColor} border ${borderColor} ${textColor} rounded-lg p-3 ${placeholderColor} focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent`}
          required
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-purple-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-purple-700 transition duration-300 ease-in-out disabled:opacity-70"
        >
          {isSubmitting ? "Subscribing..." : buttonText}
        </button>
      </form>
    </div>
  );
};

export default NewsletterSubscribe;
